import {
  ultraMarine, chromeYellow, spaceCadet, sanguine,
} from '@cogneed/react-utils';
import { Button, ButtonProps, styled } from '@mui/material';

interface NotificationButtonProps extends ButtonProps {
  acknowledged: boolean;
}

const StyledButton = styled((props: NotificationButtonProps) => {
  const { acknowledged, ...other } = props;
  return <Button {...other} />;
})(({ acknowledged }) => ({
  padding: '12px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  flexGrow: 1,
  gap: 12,
  borderRadius: 0,
  width: '100%',
  backgroundColor: acknowledged ? 'white' : ultraMarine[100],

  '&:hover': {
    '& .newContent .MuiTypography-body1': {
      textDecoration: 'underline',
    },
  },

  '& .MuiAvatar-root': {
    width: 40,
    height: 40,
    '&.user': {
      backgroundColor: chromeYellow[300],
      color: chromeYellow[600],
    },
    '&.owner': {
      backgroundColor: sanguine[300],
      color: sanguine[600],
    },
    '&.admin': {
      backgroundColor: ultraMarine[300],
      color: ultraMarine[600],

    },
    '& svg': {
      fontSize: 14,
    },
  },

  '& .acknowledge-indicator': {
    paddingTop: 12,
    height: 12,
    '& svg': {
      fontSize: 12,
      color: ultraMarine[500],
    },
    display: acknowledged ? 'none' : 'block',
  },
  '& .message': {
    flexGrow: 1,
    display: 'block',
    '& .MuiTypography-root': {
      textAlign: 'left',
      textTransform: 'none',
    },

    '& .deleted': {
      textDecoration: 'line-through',
    },
    '& .MuiTypography-subtitle1': {
      color: spaceCadet[800],
      fontSize: 14,
      lineHeight: '16px',
      '& strong': {
        fontWeight: 600,
        marginRight: 2,
      },
      '& .subject': {
        marginLeft: 2,
        fontWeight: 600,
        color: spaceCadet[800],
      },
    },
    '& .MuiTypography-body1': {
      marginTop: 4,
      fontSize: 13,
      lineHeight: '16px',
      display: 'flex',

      '& svg': {
        fontSize: 16,
        color: spaceCadet[400],
      },
      '& .project': {
        fontWeight: 600,
        color: spaceCadet[400],
      },
      '& .card': {
        fontWeight: 600,
        color: spaceCadet[500],
      },
    },
    '& .MuiTypography-subtitle2': {
      color: spaceCadet[400],
      fontSize: 12,
      lineHeight: '16px',
    },
    '&.newContent': {
      '& .MuiTypography-body1': {
        color: spaceCadet[800],
      },
    },
    '&.userRoleChanged': {
      '& .tag': {
        marginTop: 0,
        fontSize: 11,
        lineHeight: '12px',
      },
    },
  },
  '& .MuiTypography-body2': {
    marginTop: 4,
    lineHeight: '16px',
    display: 'flex',

    '& svg': {
      fontSize: 16,
      marginTop: 4,
      color: spaceCadet[400],
    },
  },
}));
export default StyledButton;
